import React from "react";
import { IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CircularProgress from "@mui/material/CircularProgress";

export default function RefreshButton({ onClickFunction, setValue, valueName, disabledBoolean, ariaLabel, isLoading }) {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
            }}
        >
            <IconButton
                sx={{
                    "&:hover": {
                        backgroundColor: null,
                    },
                }}
                onClick={() => {
                    onClickFunction();
                    setValue(valueName, null);
                }}
                disabled={disabledBoolean}
                aria-label={ariaLabel}
            >
                {isLoading !== undefined && isLoading === true ? <CircularProgress size={24} /> : <RefreshIcon />}
            </IconButton>
        </div>
    );
}
